import { render, staticRenderFns } from "./tasksList.vue?vue&type=template&id=e3f1e53c&"
import script from "./tasksList.vue?vue&type=script&lang=js&"
export * from "./tasksList.vue?vue&type=script&lang=js&"
import style0 from "./tasksList.vue?vue&type=style&index=0&id=e3f1e53c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports